import React from 'react';
import Evento from '../../components/evento';
import { getProp, getPropAsset, getPropMarked } from '../utils';

const EventoPreview = (props) => {
  const title = getProp(props, 'title');
  const subtitle = getProp(props, 'subtitle');
  const image = getPropAsset(props, 'image');
  const description = getPropMarked(props, 'description');

  return (
    <div className="container-xl pt-5">
      <Evento {...{ title, subtitle, image, description }} />
    </div>
  );
};

export default EventoPreview;
